export default __webpack_public_path__ + "static/media/SDAT New English Logo 2024 High-01 2.d04499f4.png";